import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const getWarrantyJobById = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/task/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_JOB,
        ActionTypes.FETCHED_TWC_WARRANTIES_JOB,
        [ActionTypes.FETCHED_TWC_WARRANTIES_JOB_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getWarrantyJobBySearch = (params = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/task${getUrlParameters(params)}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH,
        ActionTypes.FETCHED_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH,
        [
          ActionTypes.FETCHED_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getWarrantySubcontractList = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/subcontract-types',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_SUBCONTRACT_LIST,
        ActionTypes.FETCHED_TWC_WARRANTIES_SUBCONTRACT_LIST,
        [ActionTypes.FETCHED_TWC_WARRANTIES_SUBCONTRACT_LIST_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const getWarrantyPart = (part) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/part/${part}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_PART,
        [
          () => {
            return {
              'type': ActionTypes.FETCHED_TWC_WARRANTIES_PART,
            };
          },
        ],
        [ActionTypes.FETCHED_TWC_WARRANTIES_PART_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getWarrantyPartsBySearch = (search) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/part${getUrlParameters(search)}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_PARTS_BY_SEARCH,
        ActionTypes.FETCHED_TWC_WARRANTIES_PARTS_BY_SEARCH,
        [ActionTypes.FETCHED_TWC_WARRANTIES_PARTS_BY_SEARCH_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const clearSearchPartWarranty = () => ({
  'type': ActionTypes.CLEAR_SEARCH_PART_WARRANTY,
});
